import { Box, Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { SabSkeleton } from "web_myplann/Shared/Skeletons";

export const AdvisorCardSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<Stack
			bgcolor={theme.palette.background.paper}
			px={theme.spacingTokens.lg}
			pt={theme.spacingTokens.lg}
			pb={theme.spacingTokens.lg}
			alignItems="center"
		>
			<SabSkeleton
				variant="circular"
				width={80}
				height={80}
				sx={{ mb: theme.spacingTokens.md }}
			/>
			<SabSkeleton variant="rounded" width="50%" height={23} />
			<SabSkeleton
				variant="rounded"
				width="35%"
				height={20}
				sx={{ mt: theme.spacingTokens.xs }}
			/>

			<Stack
				gap={theme.spacingTokens.sm}
				alignItems="center"
				width="100%"
				mt={theme.spacingTokens.lg}
				mb={theme.spacingTokens.xl}
			>
				<SabSkeleton variant="rounded" width="40%" height={20} />
				<SabSkeleton variant="rounded" width="60%" height={20} />
				<SabSkeleton variant="rounded" width="50%" height={20} />
			</Stack>

			<Box
				display="grid"
				gridTemplateColumns="repeat(2, minmax(0, 1fr))"
				gap={theme.spacingTokens.sm}
				width="100%"
			>
				<SabSkeleton
					variant="rounded"
					height={48}
					borderRadius={theme.radii.xl}
				/>
				<SabSkeleton
					variant="rounded"
					height={48}
					borderRadius={theme.radii.xl}
				/>
			</Box>
		</Stack>
	);
};
